import defaultThumbnail from '../../images/default_thumbnail.png'

const isDefaultPreview = (src: string) => {
  return src === defaultThumbnail
}

export default isDefaultPreview
